import { usePollApi } from 'hooks/usePollApi'

export function useCurrentUserId(): number | null {
  const userId =
    usePollApi<number, false>({ path: '/rpc/current_user_id' }, 60000) ?? null
  return userId
}
